import axios from '../../helpers/interceptors';

import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    TELEGRAM_AUTHORIZATION_STARTED,
    TELEGRAM_AUTHORIZATION_SUCCESS,
    TELEGRAM_AUTHORIZATION_FAILURE,
    TELEGRAM_WIDGET_AUTHORIZATION_STARTED,
    TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS,
    TELEGRAM_WIDGET_AUTHORIZATION_FAILURE,
    CLASSIC_REGISTRATION_STARTED,
    CLASSIC_REGISTRATION_SUCCESS,
    CLASSIC_REGISTRATION_FAILURE,
    CLASSIC_LOGIN_STARTED,
    CLASSIC_LOGIN_SUCCESS,
    CLASSIC_LOGIN_FAILURE,
    GOOGLE_WIDGET_AUTHORIZATION_STARTED,
    GOOGLE_WIDGET_AUTHORIZATION_SUCCESS,
    GOOGLE_WIDGET_AUTHORIZATION_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    SET_TELEGRAM_STATUS,
    SET_LINK_SCROLL_STATUS,
} from "./types";

import {api} from "../../api";
// import {clearCabinetState} from "../cabinet/action";
// // axios.defaults.withCredentials = true;
const host = api.host;


export const test = data => ({
    type: TEST,
    payload: data
});

export const setAuthorizationStatus = status => ({
    type: SET_AUTHORIZATION_STATUS,
    payload: status
});

export const setTelegramStatus = status => ({
    type: SET_TELEGRAM_STATUS,
    payload: status
});

export const setLinkScrollStatus = status => ({
    type: SET_LINK_SCROLL_STATUS,
    payload: status
});

export const telegramAuthorization = (data) => {
    let url = host + api.main.authorization;

    return dispatch => {
        dispatch(telegramAuthorizationStarted());
        axios.post(url, {initData: data})
            .then(res => {
                localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(telegramAuthorizationSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(telegramAuthorizationFailure(err.response.data.errors));
            });
    };
};

const telegramAuthorizationStarted = () => ({
    type: TELEGRAM_AUTHORIZATION_STARTED
});

export const telegramAuthorizationSuccess = serverReport => ({
    type: TELEGRAM_AUTHORIZATION_SUCCESS,
    payload: serverReport
});

export const telegramAuthorizationFailure = error => ({
    type: TELEGRAM_AUTHORIZATION_FAILURE,
    payload: error
});


export const telegramWidgetAuthorization = (data) => {
    let url = host + api.main.authorizationWidget;

    return dispatch => {
        dispatch(telegramWidgetAuthorizationStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(telegramWidgetAuthorizationSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(telegramWidgetAuthorizationFailure(err.response.data.errors));
            });
    };
};

const telegramWidgetAuthorizationStarted = () => ({
    type: TELEGRAM_WIDGET_AUTHORIZATION_STARTED
});

export const telegramWidgetAuthorizationSuccess = serverReport => ({
    type: TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS,
    payload: serverReport
});

export const telegramWidgetAuthorizationFailure = error => ({
    type: TELEGRAM_WIDGET_AUTHORIZATION_FAILURE,
    payload: error
});


export const classicRegistration = (data) => {
    let url = host + api.main.classicRegistration;

    return dispatch => {
        dispatch(classicRegistrationStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(classicRegistrationSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(classicRegistrationFailure(err.response.data.errors));
            });
    };
};

const classicRegistrationStarted = () => ({
    type: CLASSIC_REGISTRATION_STARTED
});

export const classicRegistrationSuccess = serverReport => ({
    type: CLASSIC_REGISTRATION_SUCCESS,
    payload: serverReport
});

export const classicRegistrationFailure = error => ({
    type: CLASSIC_REGISTRATION_FAILURE,
    payload: error
});


export const classicLogin = (data) => {
    let url = host + api.main.classicLogin;

    return dispatch => {
        dispatch(classicLoginStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(classicLoginSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(classicLoginFailure(err.response.data.errors));
            });
    };
};

const classicLoginStarted = () => ({
    type: CLASSIC_LOGIN_STARTED
});

export const classicLoginSuccess = serverReport => ({
    type: CLASSIC_LOGIN_SUCCESS,
    payload: serverReport
});

export const classicLoginFailure = error => ({
    type: CLASSIC_LOGIN_FAILURE,
    payload: error
});


export const googleWidgetAuthorization = (data) => {
    let url = host + api.main.authorizationGoogleWidget;

    return dispatch => {
        dispatch(googleWidgetAuthorizationStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(googleWidgetAuthorizationSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(googleWidgetAuthorizationFailure(err.response.data.errors));
            });
    };
};

const googleWidgetAuthorizationStarted = () => ({
    type: GOOGLE_WIDGET_AUTHORIZATION_STARTED
});

export const googleWidgetAuthorizationSuccess = serverReport => ({
    type: GOOGLE_WIDGET_AUTHORIZATION_SUCCESS,
    payload: serverReport
});

export const googleWidgetAuthorizationFailure = error => ({
    type: GOOGLE_WIDGET_AUTHORIZATION_FAILURE,
    payload: error
});


export const resetPassword = (data) => {
    let url = host + api.main.resetPassword;

    return dispatch => {
        dispatch(resetPasswordStarted());
        axios.post(url, data)
            .then(res => {
                // localStorage.setItem('ftf-token', res.data.response.token);
                dispatch(resetPasswordSuccess(res.data.response));
                // dispatch(setAuthorizationStatus(true));
                // dispatch(telegramAuthorizationSuccess(res));
            })
            .catch(err => {
                dispatch(resetPasswordFailure(err.response.data.errors));
            });
    };
};

const resetPasswordStarted = () => ({
    type: RESET_PASSWORD_STARTED
});

export const resetPasswordSuccess = serverReport => ({
    type: RESET_PASSWORD_SUCCESS,
    payload: serverReport
});

export const resetPasswordFailure = error => ({
    type: RESET_PASSWORD_FAILURE,
    payload: error
});







